export const GRADE_NAME_TO_GRADE_SLUG_MAP = {
  Kindergarten: 'grade-k',
  'Grade 1': 'grade-1',
  'Grade 2': 'grade-2',
  'Grade 3': 'grade-3',
  'Grade 4': 'grade-4',
  'Grade 5': 'grade-5',
  'Grade 6': 'grade-6',
  'Grade 7': 'grade-7',
  'Grade 8': 'grade-8',
}

export const ACTIVITY_NAME_TO_SLUG_MAP = {
  'No lessons marked done': 'none',
  'Lesson done in last 14 days': '14-days',
}

export const UNIT_RANGE_NAME_TO_SLUG_MAP = {
  'Units 1-4': 'core',
  'Recognizing Bullying and Harassment Unit': 'rbhu',
}
